import getBrowserTimeZone from '../../getBrowserTimeZone';
import * as React from 'react';
import { withStyles } from '@material-ui/core';
// $FlowFixMe
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { EDITOR_MODE, DEFAULT_FONT_SIZE } from '../constants';
import styles from './date.styles';

type PropType = {
  classes: Object,
  value: string,
  handleBlur: Function,
  handleChange: Function,
  mode: $Keys<typeof EDITOR_MODE>,
  docId: number,
  zoom: number,
  disabled: boolean
}

class DateC extends React.PureComponent<PropType, null> {

  render() {
    const {
      value, field, zoom,
    } = this.props;

    const fontSizeAdjusted = field.fontSize ? field.fontSize * zoom : DEFAULT_FONT_SIZE * zoom;
    const timeZone = moment.tz(getBrowserTimeZone()).format('z');

    return (
      <div style={{ fontSize: fontSizeAdjusted }}>
        {value ? (`${moment(moment(value)).format('MMMM D YYYY, h:mm a')} ${timeZone}`) : 'FILL DATE'}
      </div>
    );
  }

}

export default withStyles(styles)(DateC);
